import Page from "../../finwell/pages/Page";
import Loader from "../../components/Loader/Loader";
import { useEffect, useState } from "react";
import SystemUsageReportHomeSection from "../../components/Reports/SystemUsageReports/SystemUsageReportHomeSection";
import CONFIG from "../../utils/config";

export const SystemUsageReportsMobile = () => {
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    useEffect(() => {
        window.scrollTo(0, 0);

        let sendHeight = setInterval(() => {
            let obj = { 'method': 'height', 'value': document.getElementById("root").scrollHeight+50 }
            console.log('height: ', obj);
            window.parent.postMessage(obj, "*");
        }, 3000)

        return (() => { clearInterval(sendHeight) })
    }, [])

    return (
        <>
        <div className="container pb-2rem">
            <Loader start={isLoading} />
            {/* <Page> */}
                <SystemUsageReportHomeSection
                    setIsLoading={setIsLoading} 
                    isLoading={isLoading}
                    isMobile={true}
                />
            </div>
            {/* </Page> */}
        </>
    )
}

export default SystemUsageReportsMobile;